/* eslint-disable */
import Timer from "../components/Timer";

export default function Summary() {



  return (
    <>
      <div className="summaryBox">

        <img src="/checkout/images/easypaisa-approval.jpeg" style={{ width: '200px', marginLeft: 'auto', marginRight: 'auto' }} />
        <Timer />
      </div>
      <br />
      <br />
      <br />


    </>
  );
}
